/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArtifactWidgetListingsSearchContent } from './ArtifactWidgetListingsSearchContent';
import {
    ArtifactWidgetListingsSearchContentFromJSON,
    ArtifactWidgetListingsSearchContentFromJSONTyped,
    ArtifactWidgetListingsSearchContentToJSON,
    ArtifactWidgetListingsSearchContentToJSONTyped,
} from './ArtifactWidgetListingsSearchContent';

/**
 * 
 * @export
 * @interface ArtifactWidgetListingsSearch
 */
export interface ArtifactWidgetListingsSearch {
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingsSearch
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingsSearch
     */
    messageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingsSearch
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingsSearch
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactWidgetListingsSearch
     */
    kind: ArtifactWidgetListingsSearchKindEnum;
    /**
     * 
     * @type {ArtifactWidgetListingsSearchContent}
     * @memberof ArtifactWidgetListingsSearch
     */
    content: ArtifactWidgetListingsSearchContent;
}


/**
 * @export
 */
export const ArtifactWidgetListingsSearchKindEnum = {
    WidgetListingsSearch: 'widget-listings-search'
} as const;
export type ArtifactWidgetListingsSearchKindEnum = typeof ArtifactWidgetListingsSearchKindEnum[keyof typeof ArtifactWidgetListingsSearchKindEnum];


/**
 * Check if a given object implements the ArtifactWidgetListingsSearch interface.
 */
export function instanceOfArtifactWidgetListingsSearch(value: object): value is ArtifactWidgetListingsSearch {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ArtifactWidgetListingsSearchFromJSON(json: any): ArtifactWidgetListingsSearch {
    return ArtifactWidgetListingsSearchFromJSONTyped(json, false);
}

export function ArtifactWidgetListingsSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactWidgetListingsSearch {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'messageId': json['messageId'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'kind': json['kind'],
        'content': ArtifactWidgetListingsSearchContentFromJSON(json['content']),
    };
}

export function ArtifactWidgetListingsSearchToJSON(json: any): ArtifactWidgetListingsSearch {
    return ArtifactWidgetListingsSearchToJSONTyped(json, false);
}

export function ArtifactWidgetListingsSearchToJSONTyped(value?: ArtifactWidgetListingsSearch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'messageId': value['messageId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'kind': value['kind'],
        'content': ArtifactWidgetListingsSearchContentToJSON(value['content']),
    };
}

